import { PolymerElement, html } from '@polymer/polymer/polymer-element.js';
import '@polymer/paper-card/paper-card.js';
/**
 * `cbar-messagepreview`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CommunitybuildarMessagepreview extends PolymerElement {
  static get template() {
    return html`
    <style>
      :host {
        display: block;
        font-family: "Helvetica Neue", Helvetica, Arial, Geneva, sans-serif;
        font-weight: 200;
      }

      /* styling for the card which holds everything else*/
      paper-card {
        width: 100%;
        resize: both;
      }

      /* styling for the information displays intended to be on the top right hand corner of the card*/
      .right {
        text-align: right;
      }

      /*styling for the div that holds the body of the message, or the template for the message to sit in*/
      div {
        width: 95%;
        margin: 0 auto;
        padding: 10px;
      }
      /* Styling only for the message contained within the slot in the element.*/
      #message-container {
        padding: 0;
        width: 100%;

      }
      #subject-container{
        font-size: x-large;
        margin-top: 1%;

      }

      /*Styling for the top section of the card holding all the information about the email*/
      span {
        color: #2b2b2d;
        width: 100%;
      }

      #status-container{
        color: #007fc3;
      }

      /*HR styling for better looking break*/
      hr {
        -webkit-margin-after: 0;
        -webkit-margin-before: 0;
      }

      /*Styling of the slotted material used to resize based on mobile devices*/
      #message ::slotted([slot="message"]) {
        width: 100% !important;
        max-width: 100% !important;
      }

      /*if no status or message date given, hide the containers holding them*/
      [hidden] {
        display: none;
      }

      .flex-container {
        display: flex;
        justify-content: space-between;
      }

    </style>

    <!--
    This contains the general layout intended for the element to use, this contains the displaying of the 4 possible pieces of information needed from the element
    as well as the displaying of the message derived from an external source.

    This element essentially acts as a container for the information regarding an email to be displayed in.
    -->
    <paper-card elevation="1">
      <div class="card-content flex-container">
        <span hidden$="[[!subject]]" id="subject-container">[[subject]]</span>
        <div class="right" id="status-container" hidden$="[[!status]]">[[status]]</div>
      </div>
      <div class="card-content flex-container">
        <span id="touser-container"><b>To: </b> <span hidden$="[[!toUsername]]">[[toUsername]] </span> <span hidden\$="[[!toEmail]]">&lt;[[toEmail]]&gt;</span></span>
      </div>
      <div class="card-content flex-container">
        <span id="fromuser-container"><b>From: </b> <span hidden$="[[!fromUsername]]">[[fromUsername]] </span><span hidden$="[[!fromEmail]]">&lt;[[fromEmail]]&gt;</span></span>
        <span class="right" id="sent-date-container"><b hidden$="[[!sentDate]]" id="dateCheck">Sent: </b><span hidden$="[[!sentDate]]">[[sentDate]]</span></span>
      </div>
      <div class="card-content" id="message-container">
        <slot on-slotchange="messageChanged" id="message-slot" name="message-slot"></slot>
      </div>
    </paper-card>
`;
  }

  static get is() {
      return 'cbar-messagepreview';
  }

  /**
   * Properties that are used in the element, all values are defined from exterior imports which allows for dynamic viewing
   * sent date and status are set to false in order to make them hide by default but allows for the change of such to make them visible.
   *
   * @returns {{subject: {type: String}, fromUser: {type: String}, message: {type: String}, testing: {type: String, value: string}, status: {type: String, value: boolean}, sentDate: {type: String, value: boolean}}}
   */
  static get properties() {
      return {
          subject: {
              type: String,
              value: false
          },
          fromEmail: {
              type: String,
              value: false
          },
          message: {
              type: String,
              value: false

          },
          testing: {
              type: String,
              value: "Works"
          },
          status: {
              type: String,
              value: false
          },
          sentDate: {
              type: String,
              value: false
          },
          fromUsername: {
              type: String,
              value: false
          },
          toEmail: {
              type: String,
              value: false
          },
          toUsername: {
              type: String,
              value: false
          }
      }
  }

  /**
   * when the message value is changed we want the message to be injected into the shadow dom in order for all the styling to be protected and the template styles
   * are preserved.
   * @param e
   */
  messageChanged() {
      for( let node of this.$['message-slot'].assignedNodes()) {
          this.$['message-container'].appendChild(node);
      }
  }

  ready() {
      super.ready();
      this.hideTo();
      this.hideFrom();

      if(this.$['message-slot'].assignedNodes().length > 0 ){
          this.messageChanged();
      }

  }


  hideTo() {
      if( !this.toEmail && !this.toUsername ) {
          this.$['touser-container'].hidden = true;
      }
  }

  hideFrom() {
      if( !this.fromEmail && !this.fromUsername ) {
          this.$['fromuser-container'].hidden = true;

      }
  }
}

window.customElements.define(CommunitybuildarMessagepreview.is, CommunitybuildarMessagepreview);
